export const sexEnum = [
  {
    id: 'DOG',
    name: 'Pes',
    label: 'Pes',
  },
  {
    id: 'BITCH',
    name: 'Fena',
    label: 'Fena',
  },
  {
    id: 'UNKNOWN',
    name: 'Neznámé',
    label: 'Neznámé',
  },
];

export const stateEnum = [
  {
    id: 'REGISTERED',
    name: 'Registrovaný',
    label: 'Registrovaný',
  },
  {
    id: 'NONREGISTERED',
    name: 'Neregistrovaný',
    label: 'Neregistrovaný',
  },
  {
    id: 'EXTERNAL',
    name: 'Externí',
    label: 'Externí',
  },
];



// WEBPACK FOOTER //
// ./src/modules/dogs/_dogsEnums.ts